import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import React from 'react';
export interface FormLabelProps {
  children: string;
  id: string;
}
const FormLabel = ({
  children,
  id
}: FormLabelProps): JSX.Element => <div>
        <label htmlFor={id} className="form-label__label-2td5l1">
            {children}
        </label>
    </div>;
export default FormLabel;